<template>
  <div class="content container-fluid">
    <!-- Begin: Popover for Filter -->
    <popover
      name="popEmployee"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranEmployee"
        :options="colFilter.tranEmployeeColFilter"
        :multiple="true"
      ></multiselect>
    </popover>
    <!-- End: Popover for Filter -->

    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            {{
              role == "admin"
                ? "Employees' Benefit Options"
                : "My Benefit Options"
            }}
          </h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button
            v-if="
              role == 'admin' ||
              (role == 'employee' &&
                isEnrolmentOpen &&
                !hasSubmittedForCurrentYear)
            "
            class="btn add-btn"
            @click="$router.push({ name: 'employeeBenefitOptionAdd' })"
          >
            <i class="fa fa-plus"></i>New Benefit Option
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Pagination -->
    <div class="row">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th
                  v-if="
                    role == 'admin' || (role == 'employee' && isEnrolmentOpen)
                  "
                  class="text-center"
                  style="width: 5%"
                >
                  Action
                </th>
                <th v-if="role == 'admin'">
                  <i
                    class="fa fa-filter"
                    v-popover:popEmployee
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranEmployee.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  Employee Name (Emp ID)
                </th>
                <th>Effective Date</th>
                <th>Benefit Option</th>
                <th v-for="item in benefitItems" :key="item.BenefitItem">
                  {{ item.BenefitItem }}
                </th>
                <th>Acknowledged By</th>
                <th>Acknowledgement Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in benefitOptions" :key="item.Id">
                <td
                  v-if="
                    role == 'admin' || (role == 'employee' && isEnrolmentOpen)
                  "
                  :class="item.Type == 'Prorate' ? 'prorate' : ''"
                >
                  <template v-if="item.Type == 'Benefit'">
                    <router-link
                      v-if="role == 'admin'"
                      class="btn"
                      title="Edit"
                      :to="{
                        name: 'employeeBenefitOptionEdit',
                        params: { id: item.Id },
                      }"
                    >
                      <i class="fa fa-edit"></i>
                    </router-link>
                    <button
                      v-if="role == 'admin'"
                      class="btn"
                      title="Delete"
                      @click="remove(item.Id)"
                    >
                      <i class="fa fa-trash-o"></i></button
                  ></template>
                </td>
                <td
                  v-if="role == 'admin'"
                  :class="item.Type == 'Prorate' ? 'prorate' : ''"
                >
                  {{ item.Type == "Prorate" ? "" : item.Employee }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.EffectiveDateDisplay }}
                </td>
                <td>
                  {{ item.BenefitOptionDescription }}
                </td>
                <td v-for="(benefitItem, i) in item.BenefitItems" :key="i">
                  {{
                    item.Type == "Prorate" && !benefitItem.Value
                      ? "N.A"
                      : benefitItem.Value
                  }}
                </td>

                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.ModifiedBy }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.ModifiedDateDisplay }}
                </td>
              </tr>
              <tr v-if="benefitOptions && !benefitOptions.length">
                <td
                  :colspan="
                    role == 'admin'
                      ? '6'
                      : role == 'employee' && isEnrolmentOpen
                      ? '5'
                      : '4'
                  "
                  class="text-center"
                >
                  {{ this.noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="benefitOptions && benefitOptions.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          benefitOptions.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      benefitOptions: null,
      isEnrolmentOpen: false,
      hasSubmittedForCurrentYear: false,
      noRecordText: config.NO_RECORD_TEXT,
      //for pagination
      searchColFilter: {
        tranEmployee: [],
      },
      colFilter: {},
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 100,
        Sizes: [5, 10, 20, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    benefitItems() {
      if (this.benefitOptions && this.benefitOptions.length)
        return this.benefitOptions[0].BenefitItems;
      else return [];
    },
    searchFilter() {
      return [{ name: "tranEmployee", val: this.searchColFilter.tranEmployee }];
    },
  },

  watch: {
    "searchColFilter.tranEmployee": function (val, oldVal) {
      this.getEmployeeBenefitOptions();
    },
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getEmployeeBenefitOptions();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },

  methods: {
    remove(id) {
      let param = {
        Token: this.token,
        Id: id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.deleteEmployeeBenefit(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getEmployeeBenefitOptions();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getEmployeeBenefitOptions() {
      let param = {
        Token: this.token,
        Search: this.paging.Search,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        searchFilter: this.searchFilter,
      };
      this.$store.state.isLoading = true;
      API.getEmployeeBenefit(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.benefitOptions = response.data.record;
            this.isEnrolmentOpen = response.data.isEnrolmentOpen;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            this.colFilter = response.data.colFilter;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }

            // loop
            if (this.benefitOptions.length > 0) {
              var nextYear = new Date().getFullYear() + 1;
              for (var index in this.benefitOptions) {
                if (this.benefitOptions[index].Year == nextYear) {
                  this.hasSubmittedForCurrentYear = true;
                }
              }
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getEmployeeBenefitOptions();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getEmployeeBenefitOptions();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getEmployeeBenefitOptions();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getEmployeeBenefitOptions();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getEmployeeBenefitOptions();
    },
  },

  created() {
    this.getEmployeeBenefitOptions();
  },
};
</script>

<style scoped>
.prorate {
  background-color: #dee2e6;
}
</style>


// WEBPACK FOOTER //
// src/components/Benefit/EmployeeBenefitOption/EmployeeBenefitOptionList.vue